import HandLikeIcon from "./HandLikeIcon.mjs";

/** @type {GlyphIcon} */
export default HandLikeIcon;